import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      width: '100vw',
      position: 'fixed',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    mainButton: {
      minWidth: 274,
      minHeight: 54,
      borderRadius: 6,
      fontWeight: 550,
      fontSize: 16,
      fontFamily: 'Inter, sans-serif',
      boxShadow: 'none',
      marginTop: 0,
      marginBottom: 0,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: 'inherit',
        color: 'inherit',
        boxShadow: 'none',
        filter: 'none',
      },
    },
    logoButton: {
      width: 180,
      height: 40,
      borderRadius: 6,
      background: '#FAFAFA',
      position: 'absolute',
      bottom: 40,
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
      cursor: 'default',
      '&:hover': {
        background: '#FAFAFA',
      },
    },
    logoImage: {
      maxWidth: '60%',
      maxHeight: '80%',
    },
    customLogo: {
      width: 170,
      height: 170,
      flexShrink: 0,
      aspectRatio: '1/1',
      marginBottom: 80,
      objectFit: 'contain',
    },
    noLogo: {
      width: 170,
      height: 170,
      flexShrink: 0,
      aspectRatio: '1/1',
      marginBottom: 80,
      boxSizing: 'border-box',
      padding: 4,
      borderRadius: 8,
      objectFit: 'contain',
    },
  });

export default styles;
